module.exports = __webpack_public_path__ + "static/media/catIntoCauldron.4d9e1e50.gif";